import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

const AboutTab = () => {
    const { t } = useTranslation();

    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    return (
        <section className="aboutValues">
            <div className="container">
                <div className="aboutPageShell">
                    <div className="featureTab aboutValues__tabs">
                        <Nav tabs>
                            <NavItem>
                                <NavLink tag="button" type="button" className={classnames({ active: activeTab === '1' })} onClick={() => toggle('1')}>
                                    {t("abouttab.about")}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag="button" type="button" className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
                                    {t("abouttab.mission")}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag="button" type="button" className={classnames({ active: activeTab === '3' })} onClick={() => toggle('3')}>
                                    {t("abouttab.vision")}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="aboutValues__content">
                            <TabPane tabId="1">
                                <div className="aboutValues__panel"><p>{t("abouttab.about_content")}</p></div>
                            </TabPane>
                            <TabPane tabId="2">
                                <div className="aboutValues__panel"><p>{t("abouttab.mission_content")}</p></div>
                            </TabPane>
                            <TabPane tabId="3">
                                <div className="aboutValues__panel"><p>{t("abouttab.vision_content")}</p></div>
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutTab;
